export class AuthenticatedFetchError extends Error {
  constructor(message, status = 0, requestId = '') {
    super(message);
    this.name = 'AuthenticatedFetchError';
    this.status = Number(status || 0);
    this.requestId = String(requestId || '');
  }
}

export function storedBearerToken() {
  return String(localStorage.getItem('token') || '').trim();
}

export async function authenticatedFetch(url, options = {}) {
  const token = storedBearerToken();
  if (!token) {
    throw new AuthenticatedFetchError(
      'Your session is unavailable. Please log in again.',
      401
    );
  }

  const headers = new Headers(options.headers || {});
  headers.set('Authorization', `Bearer ${token}`);

  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  return fetch(url, {
    ...options,
    headers,
    credentials: options.credentials || 'same-origin',
  });
}
